const namespaced = true;

const state = {
  courses: [],
  classLevel: [],
  items: []
};

const getters = {
  courses: state => state.courses,
  classLevel: state => state.classLevel,
  items: state => state.items
};

const mutations = {
  SET_COURSES: (state, payload) => (state.courses = payload),
  SET_CLASS_LEVEL: (state, payload) => (state.classLevel = payload),
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  // async fetchList({ commit, rootGetters }, payload) {
  //   try {
  //     const defaultPageable = rootGetters['table/defaultPageable'];
  //     const sortBy = payload.sortBy?.[0] ? `${payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;
  //     const params = {
  //       size: defaultPageable.limit,
  //       page: defaultPageable.currentPage - 1,
  //       search: defaultPageable.search,
  //       courseId: payload.courseId,
  //       gradeId: payload.gradeId,
  //       sortBy
  //     };

  //     let url = `/api/quiz/teacher`;
  //     if (payload.gradeId || payload.course) {
  //       url = url.concat(`/filter`);
  //     }

  //     const {
  //       data: { data }
  //     } = await window.axios.get(url, { params });
  //     const { content, totalPages, totalElements } = data;

  //     commit('SET_ITEM', content);
  //     commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
  //     commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });
  //   } catch (err) {
  //     throw err;
  //   }
  // },

  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { courseId, search, gradeId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(
        `/api/quiz/teacher?courseId=${courseId ? courseId : ''}&gradeId=${gradeId ? gradeId : ''}&search=${search ? search : ''}`
      );
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchFilter({ commit }, { courseId, search, gradeId }) {
    if (courseId) {
      const courseId = courseId;
    } else {
      courseId = '';
    }
    if (gradeId) {
      const gradeId = gradeId;
    } else {
      gradeId = '';
    }
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/quiz/teacher/filter?courseId=${courseId}&gradeId=${gradeId}&search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  save({ rootGetters }) {
    var data = rootGetters['Question/allFields'];
    data.quizQuestions.forEach(form => {
      if (form.quizTypeId == 5) {
        form.quizAnswers.forEach(quiz => {
          quiz.correctAnswer = true;
          // quiz.answer = quiz.order + '-' + quiz.quizAnswerNo;
        });
      }
    });
    return window.axios.post('/api/quiz/teacher', {
      ...data,
      schoolId: rootGetters['Auth/currentSchool']
    });
  },

  // eslint-disable-next-line no-unused-vars
  update({ rootGetters }, id) {
    var data = rootGetters['Question/allFields'];
    data.quizQuestions.forEach(form => {
      if (form.quizTypeId == 5) {
        form.quizAnswers.forEach(quiz => {
          quiz.correctAnswer = true;
          // quiz.answer = quiz.order + '-' + quiz.quizAnswerNo;
        });
      }
    });
    return window.axios.put(`/api/quiz/teacher/${id}`, {
      ...data,
      schoolId: rootGetters['Auth/currentSchool']
    });
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/quiz/teacher/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchListGradeId({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/quiz/teacher/class/${classId}/course/${courseId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  async fetchClassLevelOrCourse({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/quiz/teacher/class-level${id ? `/${id}` : ''}`);
      commit(id ? 'SET_COURSES' : 'SET_CLASS_LEVEL', data);
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, id) {
    return window.axios.delete(`/api/quiz/teacher/${id}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
